<template>
	<app-page>
		<app-heading title="Sessions" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="sessions"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					sort-by="last_access"
					sort-desc
					@update="fetchSessions"
				>
					<template v-slot:actions="{ item }">
						<app-button-confirm
							v-if="$ravello.can('session.delete')"
							color="error"
							icon="fa-ban"
							table
							label-confirm="Terminate"
							:description="`Are you sure you want to terminate session`
								+ ` for <b>${getUserName(item)}</b>?`"
							title="Terminate Session"
							@click="onDelete(item._id)"
						>
							Terminate
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			sessions: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Created on',
				value: '_id',
				sortable: true,
				format: 'datetime',
			}, {
				text: 'User',
				value: 'user',
				sortable: false,
				cb: item => this.getUserName(item),
			}, {
				text: 'Browser',
				value: 'useragent.browser',
				sortable: false,
			}, {
				text: 'OS',
				value: 'useragent.os',
				sortable: false,
			}, {
				text: 'IP',
				value: 'geo.ip',
				sortable: false,
			}, {
				text: 'Country',
				value: 'geo.country',
				sortable: false,
			}, {
				text: 'Last access',
				value: 'last_access',
				sortable: true,
				format: 'datetime',
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		getUserName({ user }) {
			if (user.firstname || user.lastname) {
				return `${user.firstname} ${user.lastname}`
			}
			return user.email
		},
		async fetchSessions(pagination) {
			const request = this.$ravello.graphql('sessions')
				.fields([
					'_id',
					'last_access',
				])
				.include(this.$ravello.graphql('useragent').fields(['browser', 'os']))
				.include(this.$ravello.graphql('geo').fields(['country', 'ip']))
				.include(this.$ravello.graphql('user').fields(['email', 'firstname', 'lastname']))
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.sessions = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.to('sessions')
					.to(id)
					.delete()
				this.refresh = true
				this.$notifications.pushAlert('success', 'Session successfully terminated')
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
